import React, { Component } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import moment from "moment";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Typography,
  CircularProgress,
  Container,
} from "@material-ui/core";
import { QueuePlayNext, DeleteForever } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import Api from "../../services/api";
import CustomizedSnackbars from "../../components/material-snackbars";
import Dropzone from "react-dropzone";
import HeaderMenu from "../../components/header-menu";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SimpleSelect from "../../components/select/simple";
import SimpleCheckBox from "../../components/checkbox/check";
import MyCheckList from "../../components/checklist/checklist";
import Footer from "../../components/footer";
import { browserHistory } from "../../helpers/history";
import Title from "../../components/title-name";
import * as Service from "../../services/hirer.service";
import * as componentActions from "../../redux/actions/customers";
import { FormattedMessage, injectIntl } from "react-intl";
import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple-create";
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";
import Autocomplete from "@material-ui/lab/Autocomplete";
class CustomerEdit extends Component {
  constructor(props) {
    super(props);
    const { userSession, customers } = this.props;

    this.globalAdm = false;
    this.isClient = true;
    if (userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
    });

    this.initialState = {
      UpdatedUser: userSession.user.id,
      id: customers.customer.id,
      name: customers.customer.name,
      email: customers.customer.email,
      active: customers.customer.active,
      blocked: customers.customer.blocked,
      document: customers.customer.document,
      website: customers.customer.website,
      phone: customers.customer.phone ? this.mtel(customers.customer.phone) : "",
      responsiblename: customers.customer.responsiblename,
      responsiblemail: customers.customer.responsiblemail,
      responsiblephone: customers.customer.responsiblephone ? this.mtel(customers.customer.responsiblephone) : "",
      hirer: customers.customer.hirer,
      hirerid: customers.customer.hirerid
    };

    this.state = {
      customer: this.initialState,
      hirerList: [],
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      error: false,
      errorMessage: {}
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.changeSimpleAutocompleteValues = this.changeSimpleAutocompleteValues.bind(this);
    this.getHirersByUser = this.getHirersByUser.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.getHirersByUser();
  }

  async getHirersByUser() {
    const { userSession } = this.props;

    this.setState({ loading: true });
    var hirers = this.globalAdm ? await Service.getAllHirer() : await Service.getHirersByUser(userSession.user.id);
    this.setState({ hirerList: hirers.data.data, loading: false });
  }

  handleInputChange(e) {
    const intl = this.props.intl;
    const name = e.target.name;
    const value = e.target.value;

    this.setState((prevState) => ({
      customer: {
        ...prevState.customer,
        [name]: value,
      },
    }));

    if (e.target.name === "phone") {
      let pVal = this.mtel(value)
      this.setState((prevState) => ({
        customer: {
          ...prevState.customer,
          ["phone"]: this.mtel(value),
        },
      }));
      let isError = false;
      if(pVal.length == 0) {
        isError = false;
      }else if(pVal.length < 14) {
        isError = true;
        this.setState({
          error: true,
          errorMessage: { phone: intl.formatMessage({ id: "phone.error.min" }) }
        })
      }else if(pVal.length > 15) {
        isError = true;
        this.setState({
          error: true,
          errorMessage: { phone: intl.formatMessage({ id: "phone.error.max" }) }
        })
      }else {
        isError = false;
      }
      if(!isError) {
        this.setState({
          error: false,
          errorMessage: {}
        })
      }
    }
    if (e.target.name === "responsiblephone") {
      this.setState((prevState) => ({
        customer: {
          ...prevState.customer,
          ["responsiblephone"]: this.mtel(value),
        },
      }));
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();

    if (this.isClient) {
      this.setState((prevState) => ({
        customer: {
          ...prevState.customer,
        },
      }));
    } else {
      this.setState((prevState) => ({
        customer: {
          ...prevState.customer,
        },
      }));
    }

    for (let key in this.state.customer) {
      if (
        key
          .toString()
          .toLowerCase()
          .indexOf("_date") > -1 ||
        key
          .toString()
          .toLowerCase()
          .indexOf("date_") > -1
      ) {
        data.append(
          key,
          moment(this.state.customer[key]).format("YYYY/MM/DD HH:mm:ss")
        );
      } else if (
        key
          .toString()
          .toLowerCase()
          .indexOf("phone") > -1
      ) {
        data.append(key, this.state.customer[key].replace(/\D/gim, ""));
      } else {
        data.append(key, this.state.customer[key]);
      }
    }

   

    this.state.files.forEach((file) => data.append("filesUpload", file));
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    Api.put("/customers", data, config)

      .then((result) => {
        if (result.data.success) {
          const formattedList = result.data.data;
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "success",
            notificationMessage: intl.formatMessage({ id: "edit.success" }),
            files: [],
          });
          this.props.addCurrent(formattedList);
          //this.componentDidMount();
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data.errors && result.data.errors[0]
                ? result.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data.errors) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              err.response && err.response.data && err.response.data.errors
                ? err.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
        } else {
          const intl = this.props.intl;

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              err.response && err.response.data.errors
                ? err.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
        }
      });
  };

  handleClick = async (e) => {
    this.setState({ loading: true });
    const intl = this.props.intl;

    const { userSession, customers } = this.props;

    let data = new FormData();
    data.append("customeremail", customers.customer.email);

    Api.put("customers/enviaremail", data)
      .then((response) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: "Email Enviado",
          item: this.initialState,
          files: [],
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response && err.response.data && err.response.data.errors
              ? err.response.data.errors[0]
              : "Erro ao processar a solicitação.",
        });
      });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }



  async changeValues(stateName, value, text = "") {
    this.setState({ loading: true });

    this.setState((prevState) => ({
      customer: {
        ...prevState.customer,
        [stateName]: value,
      },
    }));
    this.setState({ loading: false });
  }
  mtel(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d)(\d{4})$/, "$1-$2");
    return v;
  }

  async changeSimpleAutocompleteValues(e, v) {
    this.setState({ loading: true });
    const name = e;
    const value = v.id;

    this.setState(prevState => ({
      customer: {
        ...prevState.customer,
        [name]: value
      }
    }));

    this.setState({ loading: false });
  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

  render() {
    const { classes, headerMenu, customers } = this.props;
    const { customer } = this.state;

    const intl = this.props.intl;   
    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          })}
          style={{ marginBottom: 50 }}
        >
          <div className={classes.drawerHeader} />

          <Container component="main" maxWidth="xl">
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={browserHistory.goBack}
                  >
                    {<FormattedMessage id="back" />}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component="h1" variant="h5">
                {<FormattedMessage id="edit.item" />}
                <Title />
              </Typography>
              <form
                name="myForm"
                className={classes.form}
                onSubmit={this.handleSubmit}
                encType="multipart/form-data"
              >
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "hirer.name" })}
                      options={this.state.hirerList}
                      name='hirerid' 
                      stateName='hirerid'
                      changeSelect={this.changeSimpleAutocompleteValues}
                      selected={customer.hirer}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      label={intl.formatMessage({ id: "name" })}
                      inputProps={{ maxLength: 255 }}
                      autoComplete="fname"
                      variant="outlined"
                      name="name"
                      onChange={this.handleInputChange}
                      value={customer.name}
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "hirer.document" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="document"
                            onChange={this.handleInputChange}
                            value={customer.document}
                            required
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "phone" })}
                            autoComplete="fname"
                            variant="outlined"
                            name="phone"
                            onChange={this.handleInputChange}
                            value={customer.phone}
                            inputProps={{ maxLength: 15, minLength:15 }}
                            error={!!this.state.errorMessage.phone}
                            helperText={
                              this.state.errorMessage.phone &&
                              this.state.errorMessage.phone
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "website" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="website"
                            onChange={this.handleInputChange}
                            value={customer.website}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "email" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="email"
                            onChange={this.handleInputChange}
                            value={customer.email}
                            source="email"
                            type="email"
                            required
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "hirer.responsible.name" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="responsiblename"
                            onChange={this.handleInputChange}
                            value={customer.responsiblename}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "hirer.responsible.phone" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="responsiblephone"
                            onChange={this.handleInputChange}
                            value={customer.responsiblephone}
                            inputProps={{ maxLength: 15, minLength:15 }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            fullWidth
                            label={intl.formatMessage({ id: "hirer.responsible.mail" })}
                            inputProps={{ maxLength: 255 }}
                            autoComplete="fname"
                            variant="outlined"
                            name="responsiblemail"
                            onChange={this.handleInputChange}
                            value={customer.responsiblemail}
                            source="email"
                            type="email"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item xs={6} sm={6}>
                    <SimpleCheckBox
                        label={intl.formatMessage({ id: "blocked" })}
                        name="blocked"
                        stateName="blocked"
                        changeSelect={this.changeValues}
                        selected={customer.blocked}
                        />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <SimpleCheckBox
                        label={intl.formatMessage({ id: "active" })}
                        name="active"
                        stateName="active"
                        changeSelect={this.changeValues}
                        selected={customer.active}
                        />
                  </Grid>
                </Grid>
                <Grid container spacing={4} justify="flex-end">
                  <Grid item xs={12} sm={4}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      {<FormattedMessage id="save" />}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}
CustomerEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  customers: state.customers
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CustomerEdit))
);
